import { gridTpl } from '../../../../../common/grid/grid.controller';

export const administrationAccountsQualityManagersGrid = {
    bindings: {
        identifier: '@',
        title: '<',
        onSelect: '&',
        onRemove: '&'
    },
    controller: 'AdministrationAccountsQualityManagersGridController',
    ...gridTpl
};
